import { useDebounce } from "use-debounce";

import useRouteState from "./useRouteState";

export default function useSearchTerm() {
  const [searchTerm, searchTermSet] = useRouteState("searchTerm", "");
  const [searchTermDebounced] = useDebounce(searchTerm, 300);
  return [searchTerm, searchTermSet, searchTermDebounced];
}
